export default __webpack_public_path__ + "static/media/masconts.e307beaf.svg";